"use client";
import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "@/utils/localStorageUtils";
import { LocalStorageKey } from "@/utils/storageKeys";
import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export const CookiesBanner = () => {
  const t = useTranslations("CookiesBanner");
  const [showBanner, setShowBanner] = useState<boolean>(false);

  useEffect(() => {
    const bannerSeenTimestamp = getFromLocalStorage(
      LocalStorageKey.COOKIE_BANNER_SEEN,
      ""
    );
    if (bannerSeenTimestamp !== "") {
      setShowBanner(false);
    } else {
      setShowBanner(true);
    }
  }, []);

  const handleBannerDismiss = () => {
    saveToLocalStorage(
      LocalStorageKey.COOKIE_BANNER_SEEN,
      DateTime.now().toFormat("dd-MMM-yyyy h:m a")
    );
    setShowBanner(false);
  };

  if (showBanner)
    return (
      <div className="w-full h-[148px] md:h-[77px] bg-[#FFF6CC] p-3 flex flex-col sm:flex-row justify-center items-center sm:px-16 border-[#FFD100] border">
        <div className="flex flex-col sm:flex-row items-center w-full max-w-[1450px]">
          <p className="text-[15px] ">
            {t.rich("message", {
              a: (chunks) => (
                <a
                  href={`https://www.clover.com/privacy-policy`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-[#3271AB]"
                >
                  {chunks}
                </a>
              ),
            })}
          </p>
          <div
            data-testid={applyDataTestId(pom.header.dismissCookieBanner)}
            onClick={handleBannerDismiss}
            className="w-full rounded-md bg-[#727272] hover:bg-[#616161] text-white flex flex-row items-center justify-center text-[16px] font-medium h-[40px] cursor-pointer"
          >
            {t("dismiss")}
          </div>
        </div>
      </div>
    );

  return null;
};
